var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13457_10172)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13457_10172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9732 26.6077C64.7969 27.5381 64.9962 29.844 66.0856 30.7138C67.6666 31.9679 70.7954 30.7745 71.1475 33.6872C71.3933 35.7099 70.6227 36.7348 72.4827 38.2518C73.6851 39.2295 75.5717 39.5801 75.4787 41.5286C75.4255 42.6681 74.3494 44.3942 74.4557 45.4595C74.5952 46.8619 76.8737 48.3654 76.9932 49.9229C77.1128 51.4804 74.6018 53.0716 74.4557 54.5482C74.3228 55.8832 75.7776 57.6902 75.3923 59.214C74.9605 60.9333 72.2569 61.2772 71.5062 62.7335C70.7888 64.1225 71.566 65.9631 70.822 67.3049C69.9385 68.8961 67.3278 68.3028 66.079 69.2939C64.8301 70.285 64.6973 73.218 63.5148 73.6967C61.8408 74.3844 60.0273 73.2719 58.3998 73.7776C57.1576 74.1687 56.2077 76.7173 54.8326 76.96C53.2117 77.2499 51.5444 75.2879 50.0763 75.2272C48.5683 75.1598 46.7947 77.2567 45.1406 76.96C43.7655 76.7173 42.8156 74.1619 41.5734 73.7776C40.0522 73.2989 37.9464 74.3574 36.5979 73.7843C35.3822 73.2652 35.0235 70.1839 33.9009 69.2872C32.6786 68.3162 30.2008 68.8759 29.2508 67.4262C28.3607 66.0778 29.2176 64.1629 28.4803 62.7268C27.7429 61.2906 24.6805 60.7647 24.5012 58.8499C24.375 57.5351 25.6637 55.8495 25.5308 54.5347C25.398 53.1526 23.0663 51.5816 22.9999 50.0915C22.9268 48.4935 25.3847 46.9091 25.5308 45.4527C25.6504 44.2728 24.3816 42.4051 24.5012 41.1376C24.6938 39.1351 27.6898 38.7845 28.4803 37.2607C29.2043 35.865 28.4006 33.6265 29.2442 32.3927C29.955 31.3476 32.838 31.5499 33.9009 30.7071C35.0368 29.8036 35.3756 26.7493 36.465 26.3043C38.139 25.6165 39.9392 26.7358 41.58 26.2233C42.8223 25.8323 43.7722 23.2837 45.1473 23.0409C46.8013 22.7443 48.575 24.8412 50.0829 24.7737C51.5909 24.7063 53.0058 22.7173 54.8392 23.0342C56.2077 23.2702 57.1642 25.8323 58.4065 26.2166C59.9542 26.7021 62.8904 25.3805 63.9665 26.6009L63.9732 26.6077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13457_10172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 46.6772C41 44.0524 42.5737 42.3846 44.8035 42.3846C47.0333 42.3846 48.588 44.0282 48.588 46.6772C48.588 49.3262 47.0333 50.9698 44.8035 50.9698C42.5737 50.9698 41 49.302 41 46.6772ZM46.401 46.6772C46.401 45.0095 45.7686 44.207 44.8035 44.207C43.8384 44.207 43.206 45.0288 43.206 46.6772C43.206 48.3256 43.8621 49.1474 44.8035 49.1474C45.7448 49.1474 46.401 48.3449 46.401 46.6772ZM53.9271 42.5635H56.5277L46.0729 58.1289H43.4723L53.9271 42.5635ZM51.412 54.0152C51.412 51.3903 52.9857 49.7226 55.1965 49.7226C57.4073 49.7226 59 51.3903 59 54.0152C59 56.64 57.4263 58.3077 55.1965 58.3077C52.9667 58.3077 51.412 56.64 51.412 54.0152ZM56.794 54.0152C56.794 52.3716 56.1616 51.545 55.1965 51.545C54.2314 51.545 53.599 52.3474 53.599 54.0152C53.599 55.6829 54.2552 56.4853 55.1965 56.4853C56.1379 56.4853 56.794 55.6635 56.794 54.0152Z",
    fill: "#002069"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13457_10172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13457_10172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(23 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13457_10172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15.9231,
    fill: "white",
    transform: "translate(41 42.3846)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.0da4d1696d0d4df3a1cf590c79cb06f1.svg";
export { ForwardRef as ReactComponent };